export default __webpack_public_path__ + "static/media/add_icon.364ba12e.svg";